import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useCallback, useEffect, useState } from 'react';

import { UpdateMedixsPatientMobilePhoneDocument } from '~/graphql/generated/graphql';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';

type UseEditMobilePhoneArgs = {
  patientId: string;
  onCompleted: () => void;
};

export const useEditMobilePhone = ({ patientId, onCompleted }: UseEditMobilePhoneArgs) => {
  const [apiError, setApiError] = useState<string | null>(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const setPatientDetailDialogState = useSetAtom(patientDetailDialogState);

  const [updateMutation, { data }] = useMutation(UpdateMedixsPatientMobilePhoneDocument);

  useEffect(() => {
    const guestPatient = data?.updateMedixsPatientMobilePhone?.medixsPatient.guestPatients[0];
    if (!guestPatient) return;

    setPatientDetailDialogState((_state) => ({
      ..._state,
      patientId: guestPatient.id,
    }));
    onCompleted();
  }, [data, onCompleted, setPatientDetailDialogState]);

  const updateMobilePhone = useCallback(
    async (mobilePhone: string) => {
      if (!patientId) return;

      setApiError(null);
      setIsUpdating(true);

      try {
        await updateMutation({
          variables: {
            input: {
              medixsPatientId: patientId,
              mobilePhone,
            },
          },
        });
      } catch (_error) {
        setApiError(_error?.message ?? 'エラーが発生しました。');
      } finally {
        setIsUpdating(false);
      }
    },
    [patientId, updateMutation],
  );

  return {
    apiError,
    isUpdating,
    updateMobilePhone,
  };
};
